import { STEPS_FACE_SCAN_VERIFICATION } from 'Containers/ModalManager/modals/common/FaceScanVerificationModal/constants';

import type { SelfieVerificationAndFaceScanStep } from './types';

export const STEP_INTRO = 'INTRO';
export const STEP_CONSENT = 'CONSENT';
export const STEP_EDUCATION = 'EDUCATION';
export const STEP_ERROR_SESSION_INFO_FAILURE = 'STEP_ERROR_SESSION_INFO_FAILURE';
export const STEP_UNVERIFY_INFO = 'STEP_UNVERIFY_INFO';
export const STEP_CHOOSE_VERIFICATION_METHOD = 'STEP_CHOOSE_VERIFICATION_METHOD';
export const STEP_ID_PREP = 'STEP_ID_PREP';

export const STEPS: SelfieVerificationAndFaceScanStep[] = [
  STEP_INTRO,
  STEP_CONSENT,
  STEP_EDUCATION,
  STEP_UNVERIFY_INFO,
  STEP_CHOOSE_VERIFICATION_METHOD,
  STEP_ID_PREP,
  ...STEPS_FACE_SCAN_VERIFICATION,
];

export const CONSENT_SCREEN_V1 = 0;
export const CONSENT_SCREEN_V2 = 1;
export const CONSENT_SCREEN_V3 = 2;

export const ID_VERIFICAITON_OFF = 0;
export const ID_VERIFICATION_V1 = 1;

export const ID_VERIFICATION_CONSENT_FLOW = 'ID_VERIFICATION';
export const PHOTO_AND_ID_VERIFICATION_CONSENT_FLOW = 'PHOTO_AND_ID_VERIFICATION';
export const PHOTO_VERIFICATION_CONSENT_FLOW = 'PHOTO_VERIFICATION';
